import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import {
  VirtualConnectionTableDownstreamMetricsQueryVariables, VirtualConnectionTableDownstreamMetricsQuery, MetricsDisplayGridRowDataFragment, VirtualConnectionTableDownstreamMetricsFilteredByColumnQueryVariables, VirtualConnectionTableDownstreamMetricsFilteredByColumnQuery, MetricSortOrder,
  VirtualConnectionTableDownstreamMetricsFilteredByColumnDocument,
  VirtualConnectionTableDownstreamMetricsDocument,
} from '../../../../../gen-src/queries';
import { ConnectionListResult, GridSortProps, PaginatedQueryWrapper } from '../../../data-catalog-shared';
import { getRowDataForMetric, MetricsDisplayGrid, MetricsDisplayGridRowData } from '../sharedDisplayGrid/MetricsDisplayGrid';
import { MetricsValidSortFields } from '../sorting/sortProviders/MetricsGridSortProvider';

type QueryVariables = VirtualConnectionTableDownstreamMetricsQueryVariables;
type QueryResults = VirtualConnectionTableDownstreamMetricsQuery;
type QueryResultListNode = MetricsDisplayGridRowDataFragment;
type GridRowData = MetricsDisplayGridRowData;

type QueryVariablesWithFilter = VirtualConnectionTableDownstreamMetricsFilteredByColumnQueryVariables;
type QueryResultsWithFilter = VirtualConnectionTableDownstreamMetricsFilteredByColumnQuery;
type QueryResultListNodeWithFilter = MetricsDisplayGridRowDataFragment;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  const virtualConnection = resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0];
  return virtualConnection ? virtualConnection.downstreamMetricsConnection : null;
}

function selectConnectionListResultForFilteredQuery(
  resultData: QueryResultsWithFilter
): ConnectionListResult<QueryResultListNodeWithFilter> | null {
  const virtualConnection = resultData && resultData.virtualConnectionTables && resultData.virtualConnectionTables[0];
  const virtualConnectionTableColumns = virtualConnection && virtualConnection.columnsConnection && virtualConnection.columnsConnection.nodes;
  const column = virtualConnectionTableColumns && virtualConnectionTableColumns[0];
  return column ? column.downstreamMetricsConnection : null;
}

export type VirtualConnectionTableDownstreamMetricsQueryGridProps =
  GridSortProps<MetricsValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly filteredColumnId: string | null;
    readonly rowCount: number | null;
  };

export function VirtualConnectionTableDownstreamMetricsQueryGrid(props: VirtualConnectionTableDownstreamMetricsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamMetricsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredMetricsLineageGridMessage();

  return props.filteredColumnId ? (
    // Query with Selected Field as Filter
    <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionTableDownstreamMetricsFilteredByColumnDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        selectedColumnId: props.filteredColumnId,
        orderBy: props.orderBy as MetricSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResultForFilteredQuery}
      mapResultNode={getRowDataForMetric}
    >
      {({ rowStore }) => <MetricsDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyFilteredGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  ) : (
    // Query without Selection
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={VirtualConnectionTableDownstreamMetricsDocument}
      partialQueryVariables={{
        vizportalUrlId: props.vizportalUrlId,
        orderBy: props.orderBy as MetricSortOrder,
      }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={getRowDataForMetric}
    >
      {({ rowStore }) => <MetricsDisplayGrid
        rowStore={rowStore}
        emptyGridMessage={emptyGridMessage}
        rowCount={props.rowCount}
        orderBy={props.orderBy}
        updateSortOrder={props.updateSortOrder}
      />}
    </PaginatedQueryWrapper>
  );
}
